import qs from 'qs'
import request from '@/utils/request'

// ============================================================
// 政企PK答题管理端接口封装
// 后端统一约定：POST + 表单参数（@RequestParam），故全部使用 qs.stringify
// 鉴权：除登录外，请求头由 request.js 自动携带 useraxj（登录返回的 aesUser 凭证）
// ============================================================

// ==================== 认证 ====================

// 管理端登录（手机号 + 密码，返回含 aesUser 凭证的用户信息）
export function doLogin (data) {
  return request({ url: '/zqpk-auth-user/doLogin', method: 'post', data: qs.stringify(data) })
}

// 获取当前用户所属项目记录列表（登录后切换项目用）
export function getZqpkAuthUserProjectList (data) {
  return request({ url: '/zqpk-auth-user/getZqpkAuthUserProjectList', method: 'post', data: qs.stringify(data) })
}

// ==================== 用户管理 ====================

// 用户列表（分页，支持姓名/账号/岗位/部门筛选）
export function getZqpkAuthUserList (data) {
  return request({ url: '/zqpk-auth-user/getZqpkAuthUserList', method: 'post', data: qs.stringify(data) })
}

// 新增用户
export function addZqpkAuthUser (data) {
  return request({ url: '/zqpk-auth-user/addZqpkAuthUser', method: 'post', data: qs.stringify(data) })
}

// 编辑用户（zauPw 为空则不修改密码）
export function updateZqpkAuthUser (data) {
  return request({ url: '/zqpk-auth-user/updateZqpkAuthUser', method: 'post', data: qs.stringify(data) })
}

// 删除用户（逻辑删除）
export function deleteZqpkAuthUser (data) {
  return request({ url: '/zqpk-auth-user/deleteZqpkAuthUser', method: 'post', data: qs.stringify(data) })
}

// 重置用户密码
export function resetZqpkAuthUserPw (data) {
  return request({ url: '/zqpk-auth-user/resetZqpkAuthUserPw', method: 'post', data: qs.stringify(data) })
}

// ==================== 项目管理（增删改仅系统管理员） ====================

// 项目列表（分页，系统管理员查全部，项目管理员仅查所属）
export function getZqpkAuthProjectList (data) {
  return request({ url: '/zqpk-auth-project/getZqpkAuthProjectList', method: 'post', data: qs.stringify(data) })
}

// 新增项目
export function addZqpkAuthProject (data) {
  return request({ url: '/zqpk-auth-project/addZqpkAuthProject', method: 'post', data: qs.stringify(data) })
}

// 编辑项目
export function updateZqpkAuthProject (data) {
  return request({ url: '/zqpk-auth-project/updateZqpkAuthProject', method: 'post', data: qs.stringify(data) })
}

// 删除项目
export function deleteZqpkAuthProject (data) {
  return request({ url: '/zqpk-auth-project/deleteZqpkAuthProject', method: 'post', data: qs.stringify(data) })
}

// ==================== 部门管理 ====================

// 部门列表（分页）
export function getZqpkAuthDepartmentList (data) {
  return request({ url: '/zqpk-auth-department/getZqpkAuthDepartmentList', method: 'post', data: qs.stringify(data) })
}

// 新增部门
export function addZqpkAuthDepartment (data) {
  return request({ url: '/zqpk-auth-department/addZqpkAuthDepartment', method: 'post', data: qs.stringify(data) })
}

// 编辑部门
export function updateZqpkAuthDepartment (data) {
  return request({ url: '/zqpk-auth-department/updateZqpkAuthDepartment', method: 'post', data: qs.stringify(data) })
}

// 删除部门
export function deleteZqpkAuthDepartment (data) {
  return request({ url: '/zqpk-auth-department/deleteZqpkAuthDepartment', method: 'post', data: qs.stringify(data) })
}

// ==================== 题目分类 ====================

// 题目分类列表（分页）
export function getZqpkQuestionTopicClassList (data) {
  return request({ url: '/zqpk-question-topic-class/getZqpkQuestionTopicClassList', method: 'post', data: qs.stringify(data) })
}

// 新增题目分类（qtcPkWeight 为 PK 抽题权重，所有分类权重之和 ≤ 100）
export function addZqpkQuestionTopicClass (data) {
  return request({ url: '/zqpk-question-topic-class/addZqpkQuestionTopicClass', method: 'post', data: qs.stringify(data) })
}

// 编辑题目分类
export function updateZqpkQuestionTopicClass (data) {
  return request({ url: '/zqpk-question-topic-class/updateZqpkQuestionTopicClass', method: 'post', data: qs.stringify(data) })
}

// 删除题目分类
export function deleteZqpkQuestionTopicClass (data) {
  return request({ url: '/zqpk-question-topic-class/deleteZqpkQuestionTopicClass', method: 'post', data: qs.stringify(data) })
}

// ==================== 试题类型（系统字典，只读） ====================

// 试题类型列表（单选/多选/判断等）
export function getZqpkQuestionTopicTypeList (data) {
  return request({ url: '/zqpk-question-topic-type/getZqpkQuestionTopicTypeList', method: 'post', data: qs.stringify(data) })
}

// ==================== 试题管理 ====================

// 试题列表（分页，支持分类/类型/题名筛选）
export function getZqpkQuestionTopicList (data) {
  return request({ url: '/zqpk-question-topic/getZqpkQuestionTopicList', method: 'post', data: qs.stringify(data) })
}

// 新增试题（选项以 questionTopicItemListString 传 JSON 字符串）
export function addZqpkQuestionTopic (data) {
  return request({ url: '/zqpk-question-topic/addZqpkQuestionTopic', method: 'post', data: qs.stringify(data) })
}

// 编辑试题（含选项增删改差量同步）
export function updateZqpkQuestionTopic (data) {
  return request({ url: '/zqpk-question-topic/updateZqpkQuestionTopic', method: 'post', data: qs.stringify(data) })
}

// 删除试题
export function deleteZqpkQuestionTopic (data) {
  return request({ url: '/zqpk-question-topic/deleteZqpkQuestionTopic', method: 'post', data: qs.stringify(data) })
}

// 试题详情（含完整选项数据，用于详情展示与编辑回显）
export function getZqpkQuestionTopicDetails (data) {
  return request({ url: '/zqpk-question-topic/getZqpkQuestionTopicDetails', method: 'post', data: qs.stringify(data) })
}

// 批量导入试题（FormData，字段名 file；返回 data={total,success,fail,errorList}，部分失败时 result=warning）
export function importZqpkQuestionTopic (data) {
  return request({ url: '/zqpk-question-topic/importZqpkQuestionTopic', method: 'post', data })
}

// 下载批量导入模板（返回 Excel 文件流 blob）
export function downloadZqpkQuestionTopicImportTemplate () {
  return request({ url: '/zqpk-question-topic/downloadZqpkQuestionTopicImportTemplate', method: 'post', responseType: 'blob' })
}

// ==================== 试卷管理 ====================

// 试卷列表（分页，支持名称/权限/类型/状态筛选）
export function getZqpkQuestionPaperList (data) {
  return request({ url: '/zqpk-question-paper/getZqpkQuestionPaperList', method: 'post', data: qs.stringify(data) })
}

// 新增试卷
export function addZqpkQuestionPaper (data) {
  return request({ url: '/zqpk-question-paper/addZqpkQuestionPaper', method: 'post', data: qs.stringify(data) })
}

// 编辑试卷
export function updateZqpkQuestionPaper (data) {
  return request({ url: '/zqpk-question-paper/updateZqpkQuestionPaper', method: 'post', data: qs.stringify(data) })
}

// 删除试卷
export function deleteZqpkQuestionPaper (data) {
  return request({ url: '/zqpk-question-paper/deleteZqpkQuestionPaper', method: 'post', data: qs.stringify(data) })
}

// 发布/暂停试卷（qpStatus：2 已发布 / 3 已暂停）
export function updateZqpkQuestionPaperStatus (data) {
  return request({ url: '/zqpk-question-paper/updateZqpkQuestionPaperStatus', method: 'post', data: qs.stringify(data) })
}

// ==================== 答题结果 ====================

// 答题结果列表（分页，支持试卷/状态筛选）
export function getZqpkQuestionPaperRecordList (data) {
  return request({ url: '/zqpk-question-paper-record/getZqpkQuestionPaperRecordList', method: 'post', data: qs.stringify(data) })
}

// 答题结果详情（含每题题干、选项、用户作答、解析）
export function getZqpkQuestionPaperRecordDetails (data) {
  return request({ url: '/zqpk-question-paper-record/getZqpkQuestionPaperRecordDetails', method: 'post', data: qs.stringify(data) })
}

// ==================== PK 试卷（对战房间） ====================

// PK 试卷列表（分页，含对战双方信息）
export function getPkqPaperList (data) {
  return request({ url: '/pkq-paper/getPkqPaperList', method: 'post', data: qs.stringify(data) })
}

// PK 试卷详情
export function getPkqPaperById (data) {
  return request({ url: '/pkq-paper/getPkqPaperById', method: 'post', data: qs.stringify(data) })
}

// 删除 PK 试卷
export function deletePkqPaper (data) {
  return request({ url: '/pkq-paper/deletePkqPaper', method: 'post', data: qs.stringify(data) })
}

// ==================== PK 全局规则 ====================

// 获取当前项目 PK 全局规则（不存在则自动初始化）
export function getPkqRuleGlobalDetails () {
  return request({ url: '/pkq-rule-global/getPkqRuleGlobalDetails', method: 'post' })
}

// 编辑 PK 全局规则（含题数、倒计时、各分值等数值校验）
export function updatePkqRuleGlobal (data) {
  return request({ url: '/pkq-rule-global/updatePkqRuleGlobal', method: 'post', data: qs.stringify(data) })
}

// ==================== 文件上传 ====================

// 上传文件到腾讯云对象存储（FormData，字段名 file；返回 data 为文件可访问 URL）
export function uploadFile (data) {
  return request({ url: '/tx-cloud-file/uploadFileToTxCloudEquityAxj', method: 'post', data })
}

// ==================== PK 用户统计 ====================

// PK用户统计列表（分页，可按用户id筛选）
export function getPkqUserStatisticsList (data) {
  return request({ url: '/pkq-user-statistics/getPkqUserStatisticsList', method: 'post', data: qs.stringify(data) })
}

// PK用户统计详情（按统计记录 pusId 查询）
export function getPkqUserStatisticsByZauId (data) {
  return request({ url: '/pkq-user-statistics/getPkqUserStatisticsByZauId', method: 'post', data: qs.stringify(data) })
}

// ==================== PK 错题记录 ====================

// PK错题记录列表（分页，可按用户id/题目id筛选）
export function getPkqUserWrongList (data) {
  return request({ url: '/pkq-user-wrong/getPkqUserWrongList', method: 'post', data: qs.stringify(data) })
}

// PK错题记录详情（含题干、选项、用户作答、对错；item 为题目快照）
export function getPkqUserWrongById (data) {
  return request({ url: '/pkq-user-wrong/getPkqUserWrongById', method: 'post', data: qs.stringify(data) })
}
